import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from './header';
import { auctionInsights_template } from '../components/templates/auctionInsights_template';
import { getRequestErrorMessage } from '~/utils/requestError';
export class auctionInsights extends vnModule_knockoutJS {
    constructor() {
        super(...arguments);
        this.listRequestGeneration = 0;
    }
    getModuleName() {
        return 'auction_insights';
    }
    cleanup() {
        this.tpl?.destroyDatePickerCalendar?.();
    }
    internalLoad(container) {
        this.build();
        this.insertIn(container);
        for (const element of this.content) {
            try {
                ko.applyBindings(this.viewModel, element);
            }
            catch (error) {
                console.error('Knockout binding failed for', element.id, error);
            }
        }
        this.loadSavedViewModule();
        try {
            this.fillPage();
        }
        finally {
            container.classList.remove('loading');
        }
    }
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader?.loadedModule;
        loadedModule?.setHeaderTitle('Auction Insights');
        loadedModule?.setBreadcrumbs([
            { label: 'Home', href: '/home', icon: 'home' },
            { label: 'Auction Insights', href: null },
        ]);
        this.tpl = new auctionInsights_template('auctionInsights_template', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    fillPage() {
        try {
            this.tpl.buildDatePickerCalendar();
            this.getListFormData();
        }
        catch (error) {
            console.error(error);
            this.failListLoading('Unable to initialize auction insights.');
        }
    }
    startListLoading() {
        this.tpl?.activateLoading();
    }
    completeListLoading() {
        this.tpl?.completeLoading();
    }
    failListLoading(message) {
        this.tpl?.failLoading(message);
    }
    getListFormData() {
        this.startListLoading();
        this.requestHandler = new XMLHttpRequestHandler('/api/auctionInsights/references/', [], this);
        this.requestHandler.onReadyStateFunction = this.onFilterRequestReturn;
        this.requestHandler.execute();
    }
    onFilterRequestReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
            if (req.request.status !== 200) {
                try {
                    obj.manageResponse(req, obj, undefined);
                }
                catch (error) {
                    console.error(error);
                }
                obj.failListLoading(getRequestErrorMessage(req.request, 'Unable to load auction insight filters.'));
                return;
            }
            try {
                obj.manageResponse(req, obj, function () {
                    const responseParsed = JSON.parse(req.request.response || '{}');
                    obj.updateFilters(responseParsed);
                    obj.updateViewModelFromPath();
                    obj.getData();
                });
            }
            catch (error) {
                console.error(error);
                obj.failListLoading('Auction insight filters returned an invalid response.');
            }
        };
    }
    updateFilters(responseParsed) {
        this.tpl.setBrandFilterItems(responseParsed?.brands);
        this.tpl.setProductFilterItems(responseParsed?.products);
        this.tpl.setPartnerFilterItems(responseParsed?.partners);
        this.tpl.setBuyerFilterItems(responseParsed?.buyers);
        this.tpl.setAudienceFilterItems(responseParsed?.audiences);
        this.tpl.setClickAuctionExperimentFilterItems(responseParsed?.clickAuctionExperiments);
        this.tpl.setLeadAuctionExperimentFilterItems(responseParsed?.leadAuctionExperiments);
    }
    getData() {
        const generation = ++this.listRequestGeneration;
        this.startListLoading();
        try {
            const subViewModel = this.tpl.getViewModelForRequest();
            const baseApiUrl = '/api/auctionInsights/get/';
            this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn(generation), XMLHttpRequestHandler_requestType.GET, 'getData');
        }
        catch (error) {
            console.error(error);
            this.failListLoading('Unable to request auction insights.');
        }
    }
    onDataRequestReturn(generation) {
        return (req, obj) => {
            return function () {
                if (req.request.readyState !== 4) {
                    return;
                }
                if (generation !== obj.listRequestGeneration) {
                    return;
                }
                if (req.request.status !== 200) {
                    try {
                        obj.manageResponse(req, obj, undefined);
                    }
                    catch (error) {
                        console.error(error);
                    }
                    obj.failListLoading(getRequestErrorMessage(req.request, 'Unable to refresh auction insights.'));
                    return;
                }
                try {
                    obj.manageResponse(req, obj, function () {
                        const responseParsed = JSON.parse(req.request.response || '{}');
                        obj.tpl.setStatus(responseParsed?.status);
                        obj.tpl.setCpcAggregatorWinRate(responseParsed?.cpcAggregatorWinRate ?? []);
                        obj.tpl.setCpcCarrierWinRate(responseParsed?.cpcCarrierWinRate ?? []);
                        obj.tpl.setCpcCarrierCtrs(responseParsed?.cpcCarrierCtrs ?? []);
                        obj.tpl.setCpcListingDistribution(responseParsed?.cpcListingDistribution ?? []);
                        obj.tpl.setCpcBuyers(responseParsed?.cpcBuyers ?? []);
                        obj.tpl.setLeadAggregatorWinRate(responseParsed?.leadAggregatorWinRate ?? []);
                        obj.tpl.setLeadCarrierWinRate(responseParsed?.leadCarrierWinRate ?? []);
                        obj.tpl.setLeadAggregatorFillRate(responseParsed?.leadAggregatorFillRate ?? []);
                        obj.tpl.setLeadCarrierFillRate(responseParsed?.leadCarrierFillRate ?? []);
                        obj.tpl.setLeadBuyers(responseParsed?.leadBuyers ?? []);
                        if (responseParsed?.filters) {
                            obj.tpl.setPartnerFilterItems(responseParsed.filters.partners);
                            obj.tpl.setBuyerFilterItems(responseParsed.filters.buyers);
                        }
                    });
                    obj.completeListLoading();
                }
                catch (error) {
                    console.error(error);
                    obj.failListLoading('Auction insights returned an invalid response.');
                }
            };
        };
    }
    filterDropdownOnChange() {
        this.getData();
    }
    filterMultipleSelectorOnChange(_elem) {
        this.getData();
    }
    filterDateOnChange() {
        this.getData();
    }
}
